import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_GLOBAL_SETTINGS_STATE, GLOBAL_STATE_NAME } from '../constants'

export const globalSettingsSlice = createSlice({
  name: GLOBAL_STATE_NAME.SETTINGS,
  initialState: DEFAULT_GLOBAL_SETTINGS_STATE,
  reducers: {
    updateGlobalSettings: (state, action) => Object.assign(state, action.payload),
  },
})

export const globalSettingsActions = globalSettingsSlice.actions

export const selectGlobalSettings = (state) => state[globalSettingsSlice.name]
export const selectFontSizeSetting = (state) => selectGlobalSettings(state).fontSize
export const selectOrientationSetting = (state) => selectGlobalSettings(state).orientation
export const selectEulaSetting = (state) => selectGlobalSettings(state).isEulaAccepted
